var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3935 18.1065L22 8.5M12.3935 18.1065L15.4501 24.2198C15.4884 24.3034 15.5499 24.3742 15.6273 24.4239C15.7047 24.4736 15.7948 24.5 15.8868 24.5C15.9787 24.5 16.0688 24.4736 16.1462 24.4239C16.2236 24.3742 16.2851 24.3034 16.3234 24.2198L22 8.5M12.3935 18.1065L6.28022 15.0499C6.19661 15.0116 6.12576 14.9501 6.07608 14.8727C6.02641 14.7953 6 14.7052 6 14.6132C6 14.5213 6.02641 14.4312 6.07608 14.3538C6.12576 14.2764 6.19661 14.2149 6.28022 14.1766L22 8.5",
    stroke: "#007ACC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailResults);
export default __webpack_public_path__ + "static/media/emailResults.f19ae74aa26014d18628ba1e497f324f.svg";
export { ForwardRef as ReactComponent };